// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"t2-z","dimensionLabel":"u2-z","styleChooserControlWrapper":"v2-z","styleChooserControl":"w2-z","disabled":"x2-z","giftCard":"y2-z","styleChooserText":"z2-z"};